import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Select from 'react-select';
import Moment from "moment";


const modeloDatos = {
    CxpID: 0, 
    empresaID: "PR",
    suplidorID: 1,
    nombreSuplidor: "",
    rncSuplidor: "",
    ncfSuplidor: "",
    vendedor: "",
    comentario: "",
    itbis:0.00,
    subTotal: 0.00,
    formaPago: "",
    total: 0.00,
  
    creadoPor: "",
    fechaCreado: new Date,
    fechaFactura: new Date,
    Estatus: 0,
   pagado:0.00
}

let movimiento = "";
let options1 = [];
const MovimientoAlmacen = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [ListadoSuplidor, SetListadoSuplidor] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [PagoModal, setPagoModal] = useState(false);
    const [ver, setVer] = useState(true);
    const [Listado1, SetListado1] = useState([]);
    const [busqueda, setbusqueda] = useState("");
    const [Pagado, setPagado] = useState(0.00);

   


    const handleChange = (e) => {
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }
    const handleChange1 = (e) => {

        if (e.target.name == "pagado" && e.target.value > (tabla.total - tabla.pagado)) {
            Swal.fire(
                'EL MONTO PAGADO!',
                'NO PUEDE SER MAYOR AL ENDEUADADO',
                'error'
            )
            e.target.value = 0
        }
        setPagado(e.target.value)
    }
    const handleChange2 = (e) => {
        setTabla({
            ...tabla,
            ["suplidorID"]: e.value, ["nombreSuplidor"]: e.nombreSuplidor, ["rncSuplidor"]: e.rncSuplidor, ["vendedor"]: e.vendedor
        })
    }
   

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
                (item.nombreSuplidor + item.rncSuplidor)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

   
    const obtenerDatos = async () => {
        let response = await fetch(Api + "CXP/ListaRegistroCXP");
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if (pendiente) {
                SetListado(data)
            }
            setPendiente(false)
        }
    }
    

    const EliminarLinea = async (w) => {
        let response = await fetch(Api + "VentasTrans/EliminarMovimientoAlmacenLineas/" + w);

        if (response.ok) {
            let data = await response.json()
        }
    }


   
    useEffect(() => {
        obtenerDatos();
    }, [])   
    useEffect(() => {
  
        obtenerDatosSuplidor();
    },[])
    
    const obtenerDatosSuplidor = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaSuplidor");
        if (response.ok) {
            let data = await response.json()
            SetListadoSuplidor(data)
            options1=[]
            data.map(x => {
            options1.push({ value: x.suplidorID, label: x.descripcion, nombreSuplidor: x.descripcion, rncSuplidor: x.rnc, vendedor: x.nombreVendedor})
        })
        }
    }

   
    const guardarCambios = async () => {
      

        let response;
        if (tabla.CxpID == 0) {
          
            response = await fetch(Api + "CXP/GuardarRegistroCXP", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "CXP/EditarRegistroCXP", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            setVerModal(false)
            obtenerDatos()
            let data = await response.json()
           
            cerrarModal()

            
        //    setVerModal(!verModal);
           
        } else {
            alert("error al guardar")
        }

    }

    const procesarPago = async () => {
        tabla.pagado = parseFloat(tabla.pagado)
        let response = await fetch(Api + "CXP/ProcesarPago/" + tabla.cxpID+"/"+ Pagado+"/ad/comentario");

        if (response.ok) {
            let data = await response.json()
            setPendiente(true)
            obtenerDatos()
            setPagado(0.00)
            setPagoModal(false)

        }
    }
    const Pagar = (data) => {
        setTabla(data);
        setPagoModal(true)
    }

    const abrirEditarModal = (data, v) => {
        setVer(v);
        setTabla(data);
       
     
        setVerModal(true);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
      
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.rncSuplidor,
            sortable: true,
        },
        {
            name: 'Suplidor',
            selector: row => (ListadoSuplidor.filter(x=>x.suplidorID == row.suplidorID).map(s => s.descripcion)),
            sortable: true,
        },
        {
            name: 'Sub Total',
            selector: row => formatoMoneda(row.subTotal, 'USD', 'en-US') ,
            sortable: true,
        }, {
            name: 'ITBIS',
            selector: row => formatoMoneda(row.itbis, 'USD', 'en-US') ,
            sortable: true,
        },
        {
            name: 'Total',
            selector: row => formatoMoneda(row.total, 'USD', 'en-US') ,
            sortable: true,
        }, {
            name: 'Pagado',
            selector: row => formatoMoneda(row.pagado, 'USD', 'en-US') ,
            sortable: true,
        },  {
            name: 'Fecha',
            selector: row => (Moment(row.fechaFactura).format("DD/MM/YYYY")),
            sortable: true,
        },
        {
            name: 'Estado',
            selector: row => row.estatus,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.estatus ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.estatus ? "PAGO" : "PENDIENTE"}</span>
                )
            }
        },
    
        {
            name: '',
            cell: row => (
                <>
                    {(row.estatus == 0)?
                     <>   <Button color="primary" size="sm" className="mr-2"
                            onClick={() => abrirEditarModal(row)}
                        >
                            <i className="fas fa-pen-alt"></i>
                        </Button> 
                        <Button color="success" size="sm" className="mr-2"
                            onClick={() => Pagar(row)}
                        >
                                <i className="fas fa-money-bill"></i>
                        </Button></> :

                        <Button color="primary" size="sm" className="mr-2"
                            onClick={() => abrirEditarModal(row, true)}
                        >
                            <i className="fas fa-eye"></i>
                        </Button>
                    }
                  
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    // Crear una función para formatear como moneda
    function formatoMoneda(valor, moneda = 'USD', localizacion = 'en-US') {
        const formatter = new Intl.NumberFormat(localizacion, {
            style: 'currency',
            currency: moneda
        });
        return formatter.format(valor);
    }

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de registros cuenta por pagar
                </CardHeader>
                <CardBody>
                    <Row><Col md={2}>    <Button color="success" size="sm"
                    onClick={() => setVerModal(true)}
                    >Nueva Cuenta por pagar</Button>
                </Col>
                <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  " ></Input> </Col>
            </Row>  
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal className="modal-preguntas" isOpen={verModal}>
                <ModalHeader className="modal-header1">
                  
                    <div class="box">
                        <div>   Movimiento de Cuenta por pagar </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Suplidor</Label>
                                {/*<Input bsSize="sm" type={"select"} name="suplidorID" onChange={handleChange} value={tabla.suplidorID} className="form-control"  >*/}
                                {/*     <option value={0}>Seleccionar</option>*/}
                                {/*    {*/}
                                {/*       ListadoSuplidor.map((item) => (<option key={item.suplidorID} value={item.suplidorID}>{item.descripcion}</option>))*/}
                                {/*    }*/}
                                {/*</Input>*/}
                                <Select
                                    name={"suplidorID"}
                                    defaultValue={options1.filter(x => x.value == tabla.suplidorID)[0]}
                                    onChange={handleChange2}
                                    options={options1}
                                />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>RNC</Label>
                                <Input bsSize="sm" name="rncSuplidor" onChange={handleChange} value={tabla.rncSuplidor} />
                            </FormGroup></Col>
                        <Col md={6}>
                            <FormGroup>

                                <Label>NCF</Label>
                                <Input bsSize="sm" name="ncfSuplidor" onChange={handleChange} value={tabla.ncfSuplidor} />
                            </FormGroup></Col>
                       

                        <Col md={3}>
                            <FormGroup>
                                <Label>Vendedor</Label>
                                <Input bsSize="sm" name="vendedor" onChange={handleChange} value={tabla.vendedor} />

                                {/*<Input bsSize="sm" type={"select"} name="tipoTransaccionID" onChange={handleChange} value={tabla.tipoTransaccionID} className="form-control" >*/}
                                {/*    <option value={'+'}>Entrada</option>*/}
                                {/*    <option value={'-'}>Salida</option>*/}
                                   

                                {/*</Input>*/}
                            </FormGroup>                        </Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Comentario</Label>
                                <Input bsSize="sm" name="comentario" onChange={handleChange} value={tabla.comentario} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>ITBIS</Label>
                                <Input bsSize="sm" type="number" name="itbis" onChange={handleChange} value={tabla.itbis} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>SupTotal</Label>
                                <Input bsSize="sm" type="number" name="subTotal" onChange={handleChange} value={tabla.subTotal} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Total</Label>
                                <Input bsSize="sm" type="number" name="total" onChange={handleChange} value={tabla.total} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Forma de Pago</Label>
                                <Input bsSize="sm" name="formaPago" onChange={handleChange} value={tabla.formaPago} />
                            </FormGroup></Col>
                    
                    <Col md={3}>
                            <FormGroup>

                                <Label>Fecha Factura</Label>
                                <Input bsSize="sm" type="date" name="fechaFactura" onChange={handleChange} value={Moment(tabla.fechaFactura).format('YYYY-MM-DD')} />
                            </FormGroup></Col>
                    </Row>
                    <div>
                        <Row hidden={ver}>
                        <Col md={6}>
                        <FormGroup>
                        <Label> Articulo</Label>
                                  
                            </FormGroup>
                        </Col>
                       
                       
                    </Row>
                    
                        <Row>
                       
                    </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button hidden={!ver } size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*Procesar pago*/}
            <Modal isOpen={PagoModal}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Mantenimiento de Clientes </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setPagoModal(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        
                         <p>   Suplidor: <b>{tabla.nombreSuplidor}</b>    </p>
                        <p>   Monto Pendiente de pago: <b>{formatoMoneda(tabla.total, 'USD', 'en-US')}</b>    </p>
                    
                        <Col >
                            <FormGroup>
                                <Label>Monto a Pagar</Label>
                                <Input bsSize="sm" name="pagado" onChange={handleChange1
                                } value={Pagado} />
                            </FormGroup>
                        </Col>
                      
                    </Row>
                </ModalBody>
                <ModalFooter>
                    { (Pagado  > 0)&&
                    <Button size="sm" color="primary"
                        onClick={procesarPago}
                    >Procesar Pago</Button> }
                    <Button size="sm" color="danger"
                        onClick={() => setPagoModal(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
        )

}
export default MovimientoAlmacen;